import { z } from 'zod'

import { taskSchema } from '../pangea'

/** Identity and lifecycle fields shared by every stored agronomy-table row. */
export const sharedItemSchema = z.object({
  orgCode: z.string(),
  streamId: z.string(),
  season: z.number(),
  crop: z.string(),
  task: taskSchema,
  timeFinished: z.coerce.date(),
  /**
   * The composite unique identifier for a field in Panorama ("Panorama Field ID").
   * It is a combination of the dbm serial number and field uuid.
   *
   * Different pfids do not guarantee different fields, but the same pfid
   * does guarantee the same field. Before showing a field to a user, we
   * must also join pfids on the mutable Client/Farm/Field name, which may
   * have changed since the row was written to the database.
   *
   * It's not called "fieldId" because that would be ambiguous with the
   * field's uuid.
   */
  pfid: z.string()
})
